query GetPricingReport {
	pricingReport {
		baseplateSize
		numberOfBaseplates
		nonPremiumPrice
		premiumPrice
	}
} 